const TCAIInfinityScroll = {

    initialization: function () {
        this.loadProducts();
    },

    loadProducts: function () {
        const infinityScrollPagination = document.querySelector('.tcai_results_pagination_infinity_scroll');
        const urlParameters = new URLSearchParams(window.location.search);
        const inputToken = document.getElementById('tcai_filter_input_token');

        if (!inputToken) {
            return
        }

        if (infinityScrollPagination !== null) {
            const productsBox = document.querySelector('.tcai_products');

            if (!productsBox) {
                return
            }

            let scrolledToEnd = false;

            window.addEventListener('scroll', function () {
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                if (productsBox.getBoundingClientRect().bottom <= windowHeight && !scrolledToEnd) {

                    productsBox.style.opacity = 0.2;

                    const formData = new FormData();
                    formData.append('display_products', document.querySelectorAll('.tcai_product').length);
                    formData.append('search_query', infinityScrollPagination.getAttribute('data-query'));
                    formData.append('token', inputToken.value);

                    if (urlParameters.get('brand') !== null) {
                        formData.append('brand', urlParameters.get('brand'));
                    }
                    if (urlParameters.get('category') !== null) {
                        formData.append('category', urlParameters.get('category'));
                    }

                    fetch('/module/tcai_presta_plugin/resultsajax', {
                        method: 'POST',
                        body: formData,
                    }).then(response => response.json())
                        .then(data => {
                            const lastProduct = productsBox.querySelectorAll('.tcai_product');

                            if (data.success === true) {
                                lastProduct[lastProduct.length - 1].insertAdjacentHTML('afterend', data.products);
                            } else {
                                lastProduct[lastProduct.length - 1].insertAdjacentHTML('afterend', data.message);
                            }

                            productsBox.removeAttribute('style');
                            scrolledToEnd = false;
                        });

                    scrolledToEnd = true;
                }
            });
        }
    }
}

export default TCAIInfinityScroll;